<template>
<div class="chapter">
<div class="inner_page">
<div class="_idGenObjectStyleOverride-1">
<p class="ORIM-Chapter-Title-Page-Break">Glossary</p>
<p class="Flush-left">For readers’ convenience, the author offers the following:</p>
<ul>
<li class="Glossary"><em class="italic _idGenCharOverride-1">Àdham(h)</em>: pronounced “Adam” in medieval days, now YAH dav</li>
<li class="Glossary"><em class="italic _idGenCharOverride-1">Catriona</em>: Ka CHREE na</li>
<li class="Glossary"><em class="italic _idGenCharOverride-1">Clerical hours</em>: Prime = 6 a.m.; Terce = 8–9 a.m.; Vespers = 4:30–6 p.m.</li>
<li class="Glossary"><em class="italic _idGenCharOverride-1">Father Prior</em>: the proper form of address for lead prior of a monastery</li>
<li class="Glossary"><em class="italic _idGenCharOverride-1">Gillichallum Roy</em>: Gilli HAL um; Gillichallum = “Young Malcolm”; Roy = red</li>
<li class="Glossary"><em class="italic _idGenCharOverride-1">Glen Mòr</em>: the Great Glen</li>
<li class="Glossary"><em class="italic _idGenCharOverride-1">Inver</em>: mouth of the river (i.e., Inverlochy; Inverness)</li>
<li class="Glossary"><em class="italic _idGenCharOverride-1">Ivor</em>: EE vor</li>
<li class="Glossary"><em class="italic _idGenCharOverride-1">Keekers</em>: eyes </li>
<li class="Glossary"><em class="italic _idGenCharOverride-1">Jack-o’-plate</em>: sleeveless jacket with inserted plates of iron or other padding</li>
<li class="Glossary"><em class="italic _idGenCharOverride-1">Plaid</em>: pronounced “played”; an all-purpose garment from a length of wool kilted up with a belt. Wearer flings excess length over his shoulder.</li>
<li class="Glossary"><em class="italic _idGenCharOverride-1">Sark</em>: long shirt (thigh length)</li>
<li class="Glossary"><em class="italic _idGenCharOverride-1">Wheesht </em>(as in “Hold your wheesht”): Be quiet</li>
</ul>
<p class="ORIM-Dedication"><em class="italic _idGenCharOverride-1">’S math an còcaire an t-acras,<br/>’S mairg ’ni tailleas air biadh,<br/>Fuarag eòrn’ a sàil mo bhroige,<br/>Biadh as fhearr a fhuair mi riamh.<br/></em><br/>—Alexander Stewart, 12th Earl of Mar,<br/>September 1431</p>
<p class="ORIM-Dedication ParaOverride-2" style="margin-top:2em;">Hunger is a good cook,<br/>It is pitiful to scorn food,<br/>Cold barley gruel from the heel of my shoe,<br/>The best food I ever got.<br/><br/>—English translation by David Gressett,<br/>master Gaelic instructor, 2016</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Untitled-1-2.vue?d6e7836e